import { Component, OnInit } from '@angular/core';
import { MessageService, SharedModule } from 'primeng/api';
import { TableModule } from 'primeng/table';
import { MockService } from '../../../services/mock.service';
import { InputSwitchModule } from 'primeng/inputswitch';
import { ToastModule } from 'primeng/toast';
interface Poi {
  icon: string;
  name: string;
}
@Component({
  selector: 'app-role-pois',
  standalone: true,
  imports: [SharedModule, TableModule, InputSwitchModule, ToastModule],
  templateUrl: './role-pois.component.html',
  styleUrl: './role-pois.component.scss',
})
export class RolePoisComponent implements OnInit {
  access = false;
  pois!: Poi[];
  selectedPois!: Poi;

  constructor(
    private mockService: MockService,
    private messageService: MessageService
  ) {}

  /**
   * Lifecycle hook that is called after Angular has initialized all data-bound properties of a directive.
   * It is used to perform initialization logic, such as fetching data from a service.
   *
   * This method retrieves Points of Interest (POI) from the mockService and assigns them to the `pois` property.
   *
   * @return {void} Does not return a value.
   */
  ngOnInit(): void {
    this.mockService.getPoi().then(data => {
      this.pois = data;
    });
  }

  /**
   * Toggles the access property between true and false.
   * Sends a message indicating whether access is granted or denied.
   *
   * @return {void} This method does not return a value.
   */
  accessToggle(): void {
    this.access = !this.access;
    this.messageService.add(
      this.access
        ? {
            severity: 'success',
            summary: 'Aktualisiert',
            detail: 'Zugriff gewährt',
          }
        : {
            severity: 'error',
            summary: 'Aktualisiert',
            detail: 'Zugriff verweigert',
          }
    );
  }
}
